module.exports = __webpack_public_path__ + "static/img/case_1.72bc8ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_1.jpg
// module id = JnZ6
// module chunks = 0